/**
 * users constants
 */
export const USERS_ME_SET = 'USERS_ME_SET';

export const USERS_ME_LOAD_REQUESTED = 'USERS_ME_LOAD_REQUESTED';
export const USERS_ME_LOAD_SUCCEEDED = 'USERS_ME_LOAD_SUCCEEDED';
export const USERS_ME_LOAD_FAILED = 'USERS_ME_LOAD_FAILED';
export const USERS_ME_UPDATE_REQUESTED = 'USERS_ME_UPDATE_REQUESTED';
export const USERS_ME_UPDATE_SUCCEEDED = 'USERS_ME_UPDATE_SUCCEEDED';
export const USERS_ME_UPDATE_FAILED = 'USERS_ME_UPDATE_FAILED';
